import api from "@/services";

export const apiGetTickets = async () => {
  const response = await api.get(`/api/tickets`);
  return response.data;
};

export const apiGetTicketsByEnginnerName = async (engineerName: string) => {
  const response = await api.get(`/api/tickets/assigned/${engineerName}`, {
    params: { engineerName }
  });
  return response.data;
};
type RoutePayload = {
  engineerName: string;
  date: string;
  currentLocation: {
    lat: number;
    lng: number;
  };
};
export const apiRoutes = async (
  payload: RoutePayload
) => {
  return await api.post(
    `api/engineer/optimized-routes`,
    payload
  );
};